module.exports = __webpack_public_path__ + "img/ic-chev-e.5446b0f2.svg";